import { IconSearchNotFound } from "@repo/assets/images";
import { Button } from "@repo/ui";
import { getTranslations } from "next-intl/server";
import Link from "next/link";
const SearchNotFound = async ({
  term
}) => {
  const t = await getTranslations("Common");
  return <div className="py-6 text-center" data-sentry-component="SearchNotFound" data-sentry-source-file="SearchNotFound.jsx">
      <IconSearchNotFound className="text-miniSearch-searchNotFoundIconText fill-miniSearch-searchNotFoundIconBg mx-auto" data-sentry-element="IconSearchNotFound" data-sentry-source-file="SearchNotFound.jsx" />
      <p className="font-heading py-4 text-xl font-medium md:text-4xl">
        {t("Nothing_Turned_Up")}
      </p>
      <p className="pb-4">
        {t("Could_Not_Find_Any_Relevant_Matches_For")}
        {` '${term}'`}
      </p>
      <Link href={`/`} data-sentry-element="Link" data-sentry-source-file="SearchNotFound.jsx">
        <Button variant="primary" size="md" data-sentry-element="Button" data-sentry-source-file="SearchNotFound.jsx">
          {t("Back_To_Homepage")}
        </Button>
      </Link>
    </div>;
};
export default SearchNotFound;